import Quill from 'quill';

interface QuillImport {
    Module: any;
    Clazz: Quill;
}

export default class QuillLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<QuillImport>;

    private static instance: QuillImport;

    public static load(): Promise<QuillImport>{
        if(QuillLoader.status == 0) {
            QuillLoader.status = 1;

            QuillLoader.promise = Promise.all([

                import(/* webpackChunkName: "quill-snow-css" */ 'quill/dist/quill.snow.css'),
                import(/* webpackChunkName: "quill" */ 'quill')

            ]).then(v => {

                let QuillModule = v[1];

                const Q = (QuillModule as any).default;
                const Quill_:Quill = (QuillModule as any).default as Quill;

                let exp = {
                    Module: Q,
                    Clazz: Quill_
                } as QuillImport;

                QuillLoader.instance = exp;
                QuillLoader.status = 2;

                return exp;
            });


            return QuillLoader.promise;
        }else if(QuillLoader.status == 1){
            return QuillLoader.promise;
        }else {
            return Promise.resolve(QuillLoader.instance);
        }
    }

}